import { useId } from '@react-aria/utils';
import * as React from 'react';

import * as Styled from './input-area.styles';
import type { InputAreaProps } from './input-area.types';

export const InputArea = React.forwardRef<
  HTMLInputElement | HTMLTextAreaElement,
  InputAreaProps
>(
  (
    {
      className,
      id: providedId,
      label,
      multiline,
      onChange,
      placeholder,
      value,
      ...props
    },
    forwardedRef
  ): JSX.Element => {
    const generatedId = useId();
    const id = providedId || generatedId;
    const commonProps = {
      'data-xds': 'InputArea',
      id,
      onChange,
      placeholder,
      ref: forwardedRef,
      value,
      ...props,
    };

    if (multiline) {
      return (
        <Styled.Wrapper className={className}>
          {label && (
            <Styled.VisuallyHiddenLabel htmlFor={id}>
              {label}
            </Styled.VisuallyHiddenLabel>
          )}
          <Styled.Textarea {...commonProps} {...props} />
        </Styled.Wrapper>
      );
    }

    return (
      <Styled.Wrapper className={className}>
        {label && (
          <Styled.VisuallyHiddenLabel htmlFor={id}>
            {label}
          </Styled.VisuallyHiddenLabel>
        )}
        <Styled.Input {...commonProps} {...props} />
      </Styled.Wrapper>
    );
  }
);

InputArea.displayName = 'InputArea';
